// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file tsam/v1/page.proto (package tsam.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tsam/v1/page.proto.
 */
export const file_tsam_v1_page: GenFile = /*@__PURE__*/
  fileDesc("ChJ0c2FtL3YxL3BhZ2UucHJvdG8SB3RzYW0udjEiKQoLUGFnZVJlcXVlc3QSDAoEcGFnZRgBIAEoBRIMCgRzaXplGAIgASgFIlcKDFBhZ2VSZXNwb25zZRIWCg50b3RhbF9lbGVtZW50cxgBIAEoAxITCgt0b3RhbF9wYWdlcxgCIAEoAxIMCgRwYWdlGAMgASgFEgwKBHNpemUYBCABKAUqTQoJRGlyZWN0aW9uEhkKFURJUkVDVElPTl9VTlNQRUNJRklFRBAAEhEKDURJUkVDVElPTl9BU0MQARISCg5ESVJFQ1RJT05fREVTQxACYgZwcm90bzM");

/**
 * Common pagination and sorting messages
 *
 * @generated from message tsam.v1.PageRequest
 */
export type PageRequest = Message<"tsam.v1.PageRequest"> & {
  /**
   * 1-based page number
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * Number of items per page
   *
   * @generated from field: int32 size = 2;
   */
  size: number;
};

/**
 * Describes the message tsam.v1.PageRequest.
 * Use `create(PageRequestSchema)` to create a new message.
 */
export const PageRequestSchema: GenMessage<PageRequest> = /*@__PURE__*/
  messageDesc(file_tsam_v1_page, 0);

/**
 * @generated from message tsam.v1.PageResponse
 */
export type PageResponse = Message<"tsam.v1.PageResponse"> & {
  /**
   * Total number of items
   *
   * @generated from field: int64 total_elements = 1;
   */
  totalElements: bigint;

  /**
   * Total number of pages
   *
   * @generated from field: int64 total_pages = 2;
   */
  totalPages: bigint;

  /**
   * Current page number (1-based)
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * Current page size
   *
   * @generated from field: int32 size = 4;
   */
  size: number;
};

/**
 * Describes the message tsam.v1.PageResponse.
 * Use `create(PageResponseSchema)` to create a new message.
 */
export const PageResponseSchema: GenMessage<PageResponse> = /*@__PURE__*/
  messageDesc(file_tsam_v1_page, 1);

/**
 * @generated from enum tsam.v1.Direction
 */
export enum Direction {
  /**
   * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTION_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: DIRECTION_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum tsam.v1.Direction.
 */
export const DirectionSchema: GenEnum<Direction> = /*@__PURE__*/
  enumDesc(file_tsam_v1_page, 0);

